// kapigen version 0.1.34
// eslint-disable
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
import { google } from "../google";
import { createClient } from "../../requestClientInternal";
import { CroppedImageUploadWireFormat3 as KaggleSdkCommonCroppedImageUploadWireFormat3 } from "../common";
import { DataAccessReasonWireFormat3 as KaggleSdkSecurityDataAccessReasonWireFormat3 } from "../security";
// namespace Kaggle.Sdk.Admin:
export var CreateLogMessageRequest;
(function(CreateLogMessageRequest) {
    var LogLevel;
    (function(LogLevel) {
        LogLevel["NONE"] = "none";
        LogLevel["CRITICAL"] = "critical";
        LogLevel["ERROR"] = "error";
        LogLevel["WARNING"] = "warning";
        LogLevel["INFORMATION"] = "information";
        LogLevel["DEBUG"] = "debug";
        LogLevel["TRACE"] = "trace";
    })(LogLevel = CreateLogMessageRequest.LogLevel || (CreateLogMessageRequest.LogLevel = {}));
    var LogLevelWireFormat3 = CreateLogMessageRequest.LogLevelWireFormat3 = {
        toJson: function toJson(enumVal) {
            switch(enumVal){
                case LogLevel.NONE:
                case 0:
                default:
                    return "NONE";
                case LogLevel.CRITICAL:
                case 1:
                    return "CRITICAL";
                case LogLevel.ERROR:
                case 2:
                    return "ERROR";
                case LogLevel.WARNING:
                case 3:
                    return "WARNING";
                case LogLevel.INFORMATION:
                case 4:
                    return "INFORMATION";
                case LogLevel.DEBUG:
                case 5:
                    return "DEBUG";
                case LogLevel.TRACE:
                case 6:
                    return "TRACE";
            }
        }
    };
})(CreateLogMessageRequest || (CreateLogMessageRequest = {}));
var defaultActivityLog = {
    id: 0
};
export var ActivityLogWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultActivityLog, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.logDate) {
            message.logDate = new Date(wireFormat.logDate);
        }
        return message;
    }
};
export var AddSiteConfigRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultAdminUser = {
    id: 0,
    rateLimitStatuses: []
};
export var AdminUserWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultAdminUser, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.mostRecentLog) {
            message.mostRecentLog = ActivityLogWireFormat3.fromJson(wireFormat.mostRecentLog);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.rateLimitStatuses) {
            message.rateLimitStatuses = wireFormat.rateLimitStatuses.map(function(i) {
                return RateLimitStatusWireFormat3.fromJson(i);
            });
        }
        return message;
    }
};
var defaultAutoFormModel = {
    properties: []
};
export var AutoFormModelWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultAutoFormModel, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.properties) {
            message.properties = wireFormat.properties.map(function(i) {
                return AutoFormPropertyWireFormat3.fromJson(i);
            });
        }
        return message;
    },
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.properties) {
            wireFormat.properties = message.properties.map(function(i) {
                return AutoFormPropertyWireFormat3.toJson(i);
            });
        }
        return wireFormat;
    }
};
var defaultAutoFormProperty = {
    isNullable: false,
    isReadonly: false
};
export var AutoFormPropertyWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultAutoFormProperty, wireFormat);
        if (wireFormat) {
            message.type = AutoFormPropertyTypeWireFormat3.fromJson(wireFormat.type);
        }
        return message;
    },
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.type) {
            wireFormat.type = AutoFormPropertyTypeWireFormat3.toJson(message.type);
        }
        return wireFormat;
    }
};
export var BatchResetRateLimitStatusesRequestWireFormat3 = {
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.requests) {
            wireFormat.requests = message.requests.map(function(i) {
                return ResetRateLimitStatusRequestWireFormat3.toJson(i);
            });
        }
        return wireFormat;
    }
};
var defaultBatchResetRateLimitStatusesResponse = {
    resetCount: 0
};
export var BatchResetRateLimitStatusesResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultBatchResetRateLimitStatusesResponse, wireFormat);
        return message;
    }
};
export var BulkUpdateEmergencyBannersRequestWireFormat3 = {
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.bannerConfig) {
            wireFormat.bannerConfig = EmergencyBannersConfigWireFormat3.toJson(message.bannerConfig);
        }
        return wireFormat;
    }
};
export var CreateDelegatedUserAccessTokenRequestWireFormat3 = {
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.dataAccessReason) {
            wireFormat.dataAccessReason = KaggleSdkSecurityDataAccessReasonWireFormat3.toJson(message.dataAccessReason);
        }
        return wireFormat;
    }
};
var defaultCreateDelegatedUserAccessTokenResponse = {
    token: ""
};
export var CreateDelegatedUserAccessTokenResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultCreateDelegatedUserAccessTokenResponse, wireFormat);
        return message;
    }
};
export var CreateIdmecLinkRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultCreateIdmecLinkResponse = {
    accessLinks: []
};
export var CreateIdmecLinkResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultCreateIdmecLinkResponse, wireFormat);
        return message;
    }
};
export var CreateInboxFileRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultCreateInboxFileResponse = {};
export var CreateInboxFileResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultCreateInboxFileResponse, wireFormat);
        return message;
    }
};
export var CreateIpBanRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
export var CreateLogMessageRequestWireFormat3 = {
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.level) {
            wireFormat.level = CreateLogMessageRequest.LogLevelWireFormat3.toJson(message.level);
        }
        return wireFormat;
    }
};
var defaultCreateLogMessageResponse = {};
export var CreateLogMessageResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultCreateLogMessageResponse, wireFormat);
        return message;
    }
};
export var CreateOrganizationRequestWireFormat3 = {
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.image) {
            wireFormat.image = KaggleSdkCommonCroppedImageUploadWireFormat3.toJson(message.image);
        }
        return wireFormat;
    }
};
var defaultCreateOrganizationResponse = {
    organizationId: 0
};
export var CreateOrganizationResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultCreateOrganizationResponse, wireFormat);
        return message;
    }
};
export var DeleteAllEmergencyBannersRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
export var DeleteEmergencyBannerRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
export var DeleteInboxFileRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
export var DeleteIpBanRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
export var DeleteSiteConfigRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultEmergencyBanner = {
    bannerId: "",
    messageHtml: "",
    uriPathRegex: ""
};
export var EmergencyBannerWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultEmergencyBanner, wireFormat);
        return message;
    },
    toJson: function toJson(message) {
        return message;
    }
};
var defaultEmergencyBannersConfig = {
    banners: []
};
export var EmergencyBannersConfigWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultEmergencyBannersConfig, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.banners) {
            message.banners = wireFormat.banners.map(function(i) {
                return EmergencyBannerWireFormat3.fromJson(i);
            });
        }
        return message;
    },
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.banners) {
            wireFormat.banners = message.banners.map(function(i) {
                return EmergencyBannerWireFormat3.toJson(i);
            });
        }
        return wireFormat;
    }
};
export var GetAdminUserRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
export var GetAllSiteConfigsRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
export var GetApiMethodSampleRequestRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultGetApiMethodSampleRequestResponse = {
    sampleRequest: "",
    requestProtoUri: "",
    responseProtoUri: ""
};
export var GetApiMethodSampleRequestResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultGetApiMethodSampleRequestResponse, wireFormat);
        return message;
    }
};
export var GetAutoFormModelRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
export var GetDatabaseSizeRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultGetDatabaseSizeResponse = {};
export var GetDatabaseSizeResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultGetDatabaseSizeResponse, wireFormat);
        if ((wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.databaseSize) != undefined) {
            message.databaseSize = Number(wireFormat.databaseSize);
        }
        return message;
    }
};
export var GetLoggingConfigRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultGetLoggingConfigResponse = {
    loggingConfig: ""
};
export var GetLoggingConfigResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultGetLoggingConfigResponse, wireFormat);
        return message;
    }
};
var defaultGetSiteConfigsResponse = {
    siteConfigs: []
};
export var GetSiteConfigsResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultGetSiteConfigsResponse, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.siteConfigs) {
            message.siteConfigs = wireFormat.siteConfigs.map(function(i) {
                return SiteConfigWireFormat3.fromJson(i);
            });
        }
        return message;
    }
};
var defaultInboxFile = {
    id: 0,
    virtualDirectory: "",
    fileName: "",
    contentLength: 0,
    downloadUrl: "",
    gcsUrl: ""
};
export var InboxFileWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultInboxFile, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.contentLength) {
            message.contentLength = parseInt(wireFormat.contentLength);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.uploadTime) {
            message.uploadTime = new Date(wireFormat.uploadTime);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.uploaderInfo) {
            message.uploaderInfo = InboxFileUserInfoWireFormat3.fromJson(wireFormat.uploaderInfo);
        }
        return message;
    }
};
var defaultInboxFileUserInfo = {
    id: 0,
    displayName: "",
    userUrl: "",
    tier: 0,
    thumbnailUrl: ""
};
export var InboxFileUserInfoWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultInboxFileUserInfo, wireFormat);
        return message;
    }
};
var defaultIpBan = {
    ipBanId: 0,
    ipRange: "",
    creatorUsername: "",
    comment: ""
};
export var IpBanWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultIpBan, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.createTime) {
            message.createTime = new Date(wireFormat.createTime);
        }
        return message;
    }
};
export var ListApiMethodsRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultListApiMethodsResponse = {
    methodNames: []
};
export var ListApiMethodsResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultListApiMethodsResponse, wireFormat);
        return message;
    }
};
export var ListEmergencyBannersRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultListEmergencyBannersResponse = {};
export var ListEmergencyBannersResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultListEmergencyBannersResponse, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.bannerConfig) {
            message.bannerConfig = EmergencyBannersConfigWireFormat3.fromJson(wireFormat.bannerConfig);
        }
        return message;
    }
};
export var ListInboxFilesRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultListInboxFilesResponse = {
    virtualDirectory: "",
    inboxFiles: [],
    nextPageToken: ""
};
export var ListInboxFilesResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultListInboxFilesResponse, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.inboxFiles) {
            message.inboxFiles = wireFormat.inboxFiles.map(function(i) {
                return InboxFileWireFormat3.fromJson(i);
            });
        }
        return message;
    }
};
export var ListIpBansRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultListIpBansResponse = {
    ipBans: [],
    nextPageToken: ""
};
export var ListIpBansResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultListIpBansResponse, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.ipBans) {
            message.ipBans = wireFormat.ipBans.map(function(i) {
                return IpBanWireFormat3.fromJson(i);
            });
        }
        return message;
    }
};
export var ListRateLimitsRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultListRateLimitsResponse = {
    rateLimits: []
};
export var ListRateLimitsResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultListRateLimitsResponse, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.rateLimits) {
            message.rateLimits = wireFormat.rateLimits.map(function(i) {
                return RateLimitWireFormat3.fromJson(i);
            });
        }
        return message;
    }
};
export var ListRateLimitStatusesRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultListRateLimitStatusesResponse = {
    filtersMatchCount: 0,
    serverTimeString: "",
    rateLimitStatuses: []
};
export var ListRateLimitStatusesResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultListRateLimitStatusesResponse, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.rateLimitStatuses) {
            message.rateLimitStatuses = wireFormat.rateLimitStatuses.map(function(i) {
                return RateLimitStatusWireFormat3.fromJson(i);
            });
        }
        return message;
    }
};
export var ListRequestTypesRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultListRequestTypesResponse = {
    requestTypes: []
};
export var ListRequestTypesResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultListRequestTypesResponse, wireFormat);
        return message;
    }
};
var defaultRateLimit = {
    name: "",
    scopes: []
};
export var RateLimitWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultRateLimit, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.scopes) {
            message.scopes = wireFormat.scopes.map(function(i) {
                return RateLimitScopeWireFormat3.fromJson(i);
            });
        }
        return message;
    }
};
var defaultRateLimitFillRate = {
    per: "",
    initialTokenCount: 0
};
export var RateLimitFillRateWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultRateLimitFillRate, wireFormat);
        if ((wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.initialTokenCount) != undefined) {
            message.initialTokenCount = Number(wireFormat.initialTokenCount);
        }
        return message;
    }
};
var defaultRateLimitScope = {
    scope: "",
    fillRates: []
};
export var RateLimitScopeWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultRateLimitScope, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.fillRates) {
            message.fillRates = wireFormat.fillRates.map(function(i) {
                return RateLimitFillRateWireFormat3.fromJson(i);
            });
        }
        return message;
    }
};
var defaultRateLimitStatus = {
    key: "",
    updateTimeString: "",
    expirationTimeString: "",
    tokensCount: 0,
    blocksCount: 0,
    initialTokensCount: 0
};
export var RateLimitStatusWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultRateLimitStatus, wireFormat);
        if ((wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.tokensCount) != undefined) {
            message.tokensCount = Number(wireFormat.tokensCount);
        }
        if ((wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.initialTokensCount) != undefined) {
            message.initialTokensCount = Number(wireFormat.initialTokensCount);
        }
        return message;
    }
};
export var ResetRateLimitStatusRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultResetRateLimitStatusResponse = {
    reset: false
};
export var ResetRateLimitStatusResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultResetRateLimitStatusResponse, wireFormat);
        return message;
    }
};
export var ResetSearchIndexesRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
export var ResetSearchIndexRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultSiteConfig = {
    name: ""
};
export var SiteConfigWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultSiteConfig, wireFormat);
        return message;
    }
};
export var TestIpBansRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultTestIpBansResponse = {
    ipBans: {}
};
export var TestIpBansResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultTestIpBansResponse, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.ipBans) {
            message.ipBans = {};
            Object.entries(wireFormat.ipBans).forEach(function(param) {
                var _param = _slicedToArray(param, 2), key = _param[0], value = _param[1];
                message.ipBans[key] = IpBanWireFormat3.fromJson(value);
            });
        }
        return message;
    }
};
export var ThrowCanonicalExceptionRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
export var UpdateAutoFormModelRequestWireFormat3 = {
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.model) {
            wireFormat.model = AutoFormModelWireFormat3.toJson(message.model);
        }
        return wireFormat;
    }
};
export var UpdateEmergencyBannerRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
export var UpdateLoggingConfigRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
export var UpdateNonGenieAutoFormModelRequestWireFormat3 = {
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.model) {
            wireFormat.model = AutoFormModelWireFormat3.toJson(message.model);
        }
        return wireFormat;
    }
};
export var UpdateSiteConfigRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
export var AutoFormPropertyType;
(function(AutoFormPropertyType) {
    AutoFormPropertyType["BOOL"] = "bool";
    AutoFormPropertyType["CODE"] = "code";
    AutoFormPropertyType["DATE_TIME"] = "dateTime";
    AutoFormPropertyType["ENUM"] = "enum";
    AutoFormPropertyType["FLOAT"] = "float";
    AutoFormPropertyType["INT"] = "int";
    AutoFormPropertyType["STRING"] = "string";
    AutoFormPropertyType["TEXT"] = "text";
})(AutoFormPropertyType || (AutoFormPropertyType = {}));
export var AutoFormPropertyTypeWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        switch(wireFormat){
            case "BOOL":
            default:
                return AutoFormPropertyType.BOOL;
            case "CODE":
                return AutoFormPropertyType.CODE;
            case "DATE_TIME":
                return AutoFormPropertyType.DATE_TIME;
            case "ENUM":
                return AutoFormPropertyType.ENUM;
            case "FLOAT":
                return AutoFormPropertyType.FLOAT;
            case "INT":
                return AutoFormPropertyType.INT;
            case "STRING":
                return AutoFormPropertyType.STRING;
            case "TEXT":
                return AutoFormPropertyType.TEXT;
        }
    },
    toJson: function toJson(enumVal) {
        switch(enumVal){
            case AutoFormPropertyType.BOOL:
            case 0:
            default:
                return "BOOL";
            case AutoFormPropertyType.CODE:
            case 1:
                return "CODE";
            case AutoFormPropertyType.DATE_TIME:
            case 2:
                return "DATE_TIME";
            case AutoFormPropertyType.ENUM:
            case 3:
                return "ENUM";
            case AutoFormPropertyType.FLOAT:
            case 4:
                return "FLOAT";
            case AutoFormPropertyType.INT:
            case 5:
                return "INT";
            case AutoFormPropertyType.STRING:
            case 6:
                return "STRING";
            case AutoFormPropertyType.TEXT:
            case 7:
                return "TEXT";
        }
    }
};
// Services related exclusively to the "Genie" admin section.
// File drop/pickup functionality.
// Admin service used for banning IP addresses (i.e. for malicious users).
export var adminClient = {
    adminService: {
        addSiteConfig: createClient(AddSiteConfigRequestWireFormat3, google.protobuf.EmptyWireFormat3, "admin.AdminService/AddSiteConfig"),
        bulkUpdateEmergencyBanners: createClient(BulkUpdateEmergencyBannersRequestWireFormat3, google.protobuf.EmptyWireFormat3, "admin.AdminService/BulkUpdateEmergencyBanners"),
        // Generate a link that allows anyone with the link to access an IDMEC record.
        // This is used in response to a request from legal to access the data we
        // stored for a user under the IDMEC jurisdiction.
        createIdmecLink: createClient(CreateIdmecLinkRequestWireFormat3, CreateIdmecLinkResponseWireFormat3, "admin.AdminService/CreateIdmecLink"),
        deleteAllEmergencyBanners: createClient(DeleteAllEmergencyBannersRequestWireFormat3, google.protobuf.EmptyWireFormat3, "admin.AdminService/DeleteAllEmergencyBanners"),
        deleteEmergencyBanner: createClient(DeleteEmergencyBannerRequestWireFormat3, google.protobuf.EmptyWireFormat3, "admin.AdminService/DeleteEmergencyBanner"),
        deleteSiteConfig: createClient(DeleteSiteConfigRequestWireFormat3, google.protobuf.EmptyWireFormat3, "admin.AdminService/DeleteSiteConfig"),
        getAdminUser: createClient(GetAdminUserRequestWireFormat3, AdminUserWireFormat3, "admin.AdminService/GetAdminUser"),
        // Returns all SiteConfigs, sorted by name.
        // This RPC will honor C#-defined flags annotated with FlagDefault if a
        // DB-specified value is not found (represented by unset Id)
        getAllSiteConfigs: createClient(GetAllSiteConfigsRequestWireFormat3, GetSiteConfigsResponseWireFormat3, "admin.AdminService/GetAllSiteConfigs"),
        getApiMethodSampleRequest: createClient(GetApiMethodSampleRequestRequestWireFormat3, GetApiMethodSampleRequestResponseWireFormat3, "admin.AdminService/GetApiMethodSampleRequest"),
        getAutoFormModel: createClient(GetAutoFormModelRequestWireFormat3, AutoFormModelWireFormat3, "admin.AdminService/GetAutoFormModel"),
        getDatabaseSize: createClient(GetDatabaseSizeRequestWireFormat3, GetDatabaseSizeResponseWireFormat3, "admin.AdminService/GetDatabaseSize"),
        getLoggingConfig: createClient(GetLoggingConfigRequestWireFormat3, GetLoggingConfigResponseWireFormat3, "admin.AdminService/GetLoggingConfig"),
        listApiMethods: createClient(ListApiMethodsRequestWireFormat3, ListApiMethodsResponseWireFormat3, "admin.AdminService/ListApiMethods"),
        listEmergencyBanners: createClient(ListEmergencyBannersRequestWireFormat3, ListEmergencyBannersResponseWireFormat3, "admin.AdminService/ListEmergencyBanners"),
        listRequestTypes: createClient(ListRequestTypesRequestWireFormat3, ListRequestTypesResponseWireFormat3, "admin.AdminService/ListRequestTypes"),
        resetSearchIndex: createClient(ResetSearchIndexRequestWireFormat3, google.protobuf.EmptyWireFormat3, "admin.AdminService/ResetSearchIndex"),
        resetSearchIndexes: createClient(ResetSearchIndexesRequestWireFormat3, google.protobuf.EmptyWireFormat3, "admin.AdminService/ResetSearchIndexes"),
        updateAutoFormModel: createClient(UpdateAutoFormModelRequestWireFormat3, google.protobuf.EmptyWireFormat3, "admin.AdminService/UpdateAutoFormModel"),
        updateEmergencyBanner: createClient(UpdateEmergencyBannerRequestWireFormat3, google.protobuf.EmptyWireFormat3, "admin.AdminService/UpdateEmergencyBanner"),
        updateLoggingConfig: createClient(UpdateLoggingConfigRequestWireFormat3, google.protobuf.EmptyWireFormat3, "admin.AdminService/UpdateLoggingConfig"),
        // Update an auto-form model that doesn't require genie access (ie no user
        // data).
        updateNonGenieAutoFormModel: createClient(UpdateNonGenieAutoFormModelRequestWireFormat3, google.protobuf.EmptyWireFormat3, "admin.AdminService/UpdateNonGenieAutoFormModel"),
        // Updates an existing non-ops SiteConfig. To update a FlagDefault-specified
        // config, use AddSiteConfig.
        updateSiteConfig: createClient(UpdateSiteConfigRequestWireFormat3, google.protobuf.EmptyWireFormat3, "admin.AdminService/UpdateSiteConfig")
    },
    debugService: {
        throwCanonicalException: createClient(ThrowCanonicalExceptionRequestWireFormat3, google.protobuf.EmptyWireFormat3, "admin.DebugService/ThrowCanonicalException")
    },
    genieService: {
        // Create a token that can be used to impersonate another user.
        createDelegatedUserAccessToken: createClient(CreateDelegatedUserAccessTokenRequestWireFormat3, CreateDelegatedUserAccessTokenResponseWireFormat3, "admin.GenieService/CreateDelegatedUserAccessToken")
    },
    inboxFileService: {
        // Creates (aka "drops") a new file into the inbox.
        createInboxFile: createClient(CreateInboxFileRequestWireFormat3, CreateInboxFileResponseWireFormat3, "admin.InboxFileService/CreateInboxFile"),
        // Deletes an existing inbox file.
        deleteInboxFile: createClient(DeleteInboxFileRequestWireFormat3, google.protobuf.EmptyWireFormat3, "admin.InboxFileService/DeleteInboxFile"),
        // Lists all available inbox files (optionally filtering to just a specific
        // directory)
        listInboxFiles: createClient(ListInboxFilesRequestWireFormat3, ListInboxFilesResponseWireFormat3, "admin.InboxFileService/ListInboxFiles")
    },
    ipBanService: {
        // Bans a particular IP range.
        createIpBan: createClient(CreateIpBanRequestWireFormat3, IpBanWireFormat3, "admin.IpBanService/CreateIpBan"),
        // Unbans an existing IP range.
        deleteIpBan: createClient(DeleteIpBanRequestWireFormat3, google.protobuf.EmptyWireFormat3, "admin.IpBanService/DeleteIpBan"),
        // Lists all active IP bans that are being enforced.
        listIpBans: createClient(ListIpBansRequestWireFormat3, ListIpBansResponseWireFormat3, "admin.IpBanService/ListIpBans"),
        // Test to see if IP address(es) is/are banned.
        testIpBans: createClient(TestIpBansRequestWireFormat3, TestIpBansResponseWireFormat3, "admin.IpBanService/TestIpBans")
    },
    loggingService: {
        // Creates a sample log message (useful for testing log reporters).
        createLogMessage: createClient(CreateLogMessageRequestWireFormat3, CreateLogMessageResponseWireFormat3, "admin.LoggingService/CreateLogMessage")
    },
    organizationsService: {
        // Create a new organization given some seed input
        createOrganization: createClient(CreateOrganizationRequestWireFormat3, CreateOrganizationResponseWireFormat3, "admin.OrganizationsService/CreateOrganization")
    },
    rateLimitService: {
        // Resets multiple rate limit statuses.
        batchResetRateLimitStatuses: createClient(BatchResetRateLimitStatusesRequestWireFormat3, BatchResetRateLimitStatusesResponseWireFormat3, "admin.RateLimitService/BatchResetRateLimitStatuses"),
        // Lists rate limit definitions.
        listRateLimits: createClient(ListRateLimitsRequestWireFormat3, ListRateLimitsResponseWireFormat3, "admin.RateLimitService/ListRateLimits"),
        // Lists all rate limits statuses (that optionally match filters).
        listRateLimitStatuses: createClient(ListRateLimitStatusesRequestWireFormat3, ListRateLimitStatusesResponseWireFormat3, "admin.RateLimitService/ListRateLimitStatuses"),
        // Resets a single rate limit status by its key.
        resetRateLimitStatus: createClient(ResetRateLimitStatusRequestWireFormat3, ResetRateLimitStatusResponseWireFormat3, "admin.RateLimitService/ResetRateLimitStatus")
    }
};
